(() => {
function init() {
 const section = document.getElementById('east-london');
 if (!section || section.dataset.sliderReady) return;
 const rail = section.querySelector('.featured-grid');
 const cards = Array.from(rail.querySelectorAll('.featured-card'));
 const nav = section.querySelector('.east-slider-nav');
 if (!nav || cards.length < 2) return;
 section.dataset.sliderReady = 'true';
 nav.hidden = false;
 const prev = nav.querySelector('[data-east-prev]');
 const next = nav.querySelector('[data-east-next]');
 const count = nav.querySelector('output');
 let active = 0, scheduled = false;
 function update() {
  const left = rail.getBoundingClientRect().left;
  let nearest = Infinity;
  cards.forEach((card,i) => {
   const distance = Math.abs(card.getBoundingClientRect().left - left);
   if (distance < nearest) { nearest = distance; active = i; }
  });
  const value = String(active+1).padStart(2,'0') + ' / ' + String(cards.length).padStart(2,'0');
  if (count.textContent !== value) count.textContent = value;
  prev.disabled = active === 0; next.disabled = active === cards.length-1;
  scheduled = false;
 }
 function move(delta) {
  const card = cards[Math.max(0,Math.min(cards.length-1,active+delta))];
  rail.scrollBy({left:card.getBoundingClientRect().left-rail.getBoundingClientRect().left, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
 }
 prev.addEventListener('click',()=>move(-1));
 next.addEventListener('click',()=>move(1));
 rail.addEventListener('scroll',()=>{if(!scheduled){scheduled=true;requestAnimationFrame(update);}}, {passive:true});
 window.addEventListener('resize',update);
 update();
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init); else init();
document.addEventListener('shopify:section:load',init);
})();